import { app } from '../../../../app';
import { Controller } from './sms-services-help.controller';

app.component('companySmsServicesHelp', {
    controller: Controller,
    templateUrl: require('./sms-services-help.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/help/sms-services-help.component.js